import { Controller } from "@hotwired/stimulus"

// DETALHE tab's controller: play/pause/seek replay (via a Stimulus outlet
// to previous_routes_map_controller.js) plus the "Velocidade"/"Deslocamento"
// row filters (design.md Decision 7c — client-side only, never re-queries
// the server; the underlying segment list is already fully rendered).
export default class extends Controller {
  static targets = ['playButton', 'pauseButton', 'row']
  static values  = { deviceKey: String }
  static outlets = ['previous-routes-map']

  connect() {
    this.boundHighlight = this.highlightRow.bind(this)
    this.minSpeed = 0
    this.movementType = ''
    this.deviceLabel = ''
  }

  previousRoutesMapOutletConnected(outlet, element) {
    element.addEventListener('previous-routes-map:positionChanged', this.boundHighlight)
  }

  previousRoutesMapOutletDisconnected(outlet, element) {
    element.removeEventListener('previous-routes-map:positionChanged', this.boundHighlight)
  }

  play() {
    if (!this.hasPreviousRoutesMapOutlet) return

    this.previousRoutesMapOutlet.play(this.deviceKeyValue)
    if (this.hasPlayButtonTarget) this.playButtonTarget.classList.add('hidden')
    if (this.hasPauseButtonTarget) this.pauseButtonTarget.classList.remove('hidden')
  }

  pause() {
    if (!this.hasPreviousRoutesMapOutlet) return

    this.previousRoutesMapOutlet.pause(this.deviceKeyValue)
    if (this.hasPauseButtonTarget) this.pauseButtonTarget.classList.add('hidden')
    if (this.hasPlayButtonTarget) this.playButtonTarget.classList.remove('hidden')
  }

  seek(event) {
    if (!this.hasPreviousRoutesMapOutlet) return

    const index = parseInt(event.currentTarget.dataset.positionIndex, 10)
    if (Number.isNaN(index)) return

    this.previousRoutesMapOutlet.seekToPosition(this.deviceKeyValue, index)
  }

  highlightRow(event) {
    const { index, deviceKey } = event.detail
    if (deviceKey !== this.deviceKeyValue) return

    this.rowTargets.forEach(row => {
      const rowIndex = parseInt(row.dataset.positionIndex, 10)
      row.classList.toggle('bg-blue-50', rowIndex === index)
    })
  }

  filterBySpeed(event) {
    this.minSpeed = parseFloat(event.currentTarget.value) || 0
    this.applyFilters()
  }

  filterByMovement(event) {
    this.movementType = event.currentTarget.value
    this.applyFilters()
  }

  filterByDevice(event) {
    this.deviceLabel = event.currentTarget.value
    this.applyFilters()
  }

  applyFilters() {
    this.rowTargets.forEach(row => {
      const speed          = parseFloat(row.dataset.velocity)
      const state           = row.dataset.state
      const device          = row.dataset.device || ''
      const passesSpeed     = !this.minSpeed || speed >= this.minSpeed
      const passesMovement  = !this.movementType || state === this.movementType
      const passesDevice    = !this.deviceLabel || device === this.deviceLabel

      row.classList.toggle('hidden', !(passesSpeed && passesMovement && passesDevice))
    })
  }
}
